export default "__VITE_ASSET__CjsbcipV__"